import {
	Box,
	Button,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	Grid,
	IconButton,
	Paper,
	Popover,
	Toolbar,
	Typography,
} from "@mui/material";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getOrderDetails } from "../../../../apis/cart/apis";

import { ArrowBack, ExpandMore } from "@mui/icons-material";
import { pick } from "lodash";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import { CreateOrderStatusHistory } from "../../../../apis/cart/Order/OrderStatusHistory";
import { FullHeightLoader } from "../../../../components/Loader/FullHeightLoader";
import { columns, options } from "../../../../utils/TableColumns/Orders/lines";
import { OrderStatusForm } from "../../components/Order/OrderStatusForm";
import { LineStatusForm } from "../../components/Product/LineStatusForm";

import { ToastContainer } from "react-toastify";
import { showToast } from "../../../../utils/toast";
import { OrderTimeLine } from "../../components/Order/OrderTimeLine";
import { ConfirmModal } from "../../components/Order/ConfirmModal";
import { IconReload } from "@tabler/icons-react";

export const Detail = () => {
	const { id } = useParams();
	const [order, setOrder] = useState(null);
	const [owner, setOwner] = useState(null);
	const [shippingAddress, setShippingAddress] = useState(null);
	const [products, setProducts] = useState([]);
	const [product, setProduct] = useState([]);
	const [loader, setLoading] = useState(true);
	const [openProductStatus, setOpenProductStatus] = useState(false);
	const [openOrderStatus, setOpenOrderStatus] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [confirmOpen, setConfirmOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [refresh, setRefresh] = useState(false);
	const navigate = useNavigate();
	const getOrderDetail = useCallback(async () => {
		setLoading(true);

		getOrderDetails(id)
			.then((res) => {
				setOrder(res);
				setOwner(res.owner);
				setShippingAddress(res.shipping_address);
				setProducts(res.lines);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [id]);

	useEffect(() => {
		getOrderDetail();
	}, [getOrderDetail]);

	const handleProductStatusOpen = (item) => {
		if (order.status?.toLowerCase() === "received") {
			setDialogOpen(true);
			setMessage(
				"Before updating product statuses, you need to update the order status to 'Processing'."
			);
		} else {
			setOpenProductStatus(true);
			setProduct(item);
		}
	};

	const handleProductStatusClose = () => {
		setOpenProductStatus(false);
		setProduct(null);
		// setMessage("Product status updated successfully!");
		getOrderDetail();
		// setConfirmOpen(true);
	};
	const handleOrderStatusOpen = () => {
		setOpenOrderStatus(true);
		setOrder(order);
	};

	const handleOrderStatusClose = () => {
		setOpenOrderStatus(false);

		window.location.reload();
		// setOrder(product);
	};

	useEffect(() => {
		setMessage(
			dialogOpen
				? "Are you sure, Do you want to Update OrderStatus from Received to Processing"
				: ""
		);
	}, [dialogOpen]);

	const updateStatus = async (order) => {
		try {
			setLoading(true);
			const formdata = {
				old_status: order.status,
				new_status: "Processing",
			};

			const res = await CreateOrderStatusHistory(order.id, formdata);

			if (res.success) {
				if (res.exists) {
					setMessage(res.message);
					setDialogOpen(true);
					setRefresh(true);
				} else {
					showToast(
						"Order status updated successfully!",
						"success",
						5000
					);

					setOrder((prev) => ({
						...prev,
						status_history: [...(prev.status_history || []), res],
						status: formdata.new_status,
					}));

					setDialogOpen(false);
				}
			} else {
				showToast(
					res.message ||
					"Failed to update order status. Please try again.",
					"error"
				);
				setDialogOpen(false);
			}
		} catch (error) {
			console.error("Failed to update order status:", error);
			showToast("Something went wrong. Please try again.", "error");
			setDialogOpen(false);
		} finally {
			setLoading(false);
			// Add any cleanup here if needed later
		}
	};

	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<Box p={3}>
			<ToastContainer />
			{loader ? (
				<FullHeightLoader />
			) : order === null ? (
				<Paper elevation={1} sx={{ p: 2 }}>
					<Toolbar>
						<Typography variant="h4" sx={{ flexGrow: 1 }}>
							Failed to fetch Order Details
						</Typography>
						<Button variant="contained" startIcon={<IconReload />}>
							Reload
						</Button>
					</Toolbar>
				</Paper>
			) : (
				<Fragment>
					<Box
						py={1}
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
						}}
					>
						<Button
							onClick={() => navigate(-1)}
							startIcon={<ArrowBack />}
							// variant="contained"
							color="primary"
						>
							Back
						</Button>
						{order.status?.toLowerCase() === "received" && (
							<Button
								variant="contained"
								onClick={() => setDialogOpen(true)}
							>
								Update Status to Processing
							</Button>
						)}
						{order.status?.toLowerCase() === "processing" && (
							<Button
								variant="contained"
								onClick={handleOrderStatusOpen}
							>
								Update Status to Confirm
							</Button>
						)}
					</Box>

					<Toolbar>
						<Typography variant="h4" sx={{ flexGrow: 1 }}>
							Order Details: #{order?.number}
							<Chip
								variant="outlined"
								color="primary"
								label={
									order.status?.toLowerCase() === "received"
										? "Order Recevied"
										: order.status
								}
								sx={{ ml: 2 }}
							>
								{/* Hi */}
							</Chip>
						</Typography>
					</Toolbar>

					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Paper elevation={1} sx={{ p: 2, height: "100%" }}>
								<OrderTimeLine order={order} />
							</Paper>
						</Grid>
						<Grid item xs={8}>
							<Paper elevation={2} sx={{ p: 2, height: "100%" }}>
								{/* <Timeline>
									{statusHistories.map((status, i) => {
										const IconComponent = status.icon;
										const isActive = currentStatus === i;

										const isUpcoming = currentStatus < i;
										const percentage =
											(status.lines.length /
												products.length) *
											100;

										return (
											<TimelineItem
												key={status.label + i}
											>
												<TimelineOppositeContent
													variant="body2"
													color="text.secondary"
												>
													{status.changed_at
														? moment(
																status.changed_at
														  ).format(
																"DD/MM/YYYY hh:mm a"
														  )
														: ""}
												</TimelineOppositeContent>

												<TimelineSeparator>
													<TimelineDot
														color={
															status.color ??
															"primary"
														}
														sx={{ borderWidth: 1 }}
														variant={
															isUpcoming
																? "outlined"
																: "filled"
														}
													>
														{IconComponent && (
															<IconComponent
																active={
																	isActive
																}
															/>
														)}
													</TimelineDot>

													{i !==
														statusHistories.length -
															1 && (
														<TimelineConnector
															sx={(theme) => ({
																height: isActive
																	? 60
																	: "inherit",
																background:
																	isActive
																		? `linear-gradient(to bottom, ${theme.palette.primary.main} ${percentage}%, ${theme.palette.grey[300]} ${percentage}%)`
																		: isUpcoming
																		? theme
																				.palette
																				.grey[300]
																		: theme
																				.palette
																				.primary
																				.main,
																position:
																	"relative",
															})}
															// sx={{
															// 	height: isActive
															// 		? 100
															// 		: "inherit",
															// 	bgcolor:
															// 		isActive
															// 			? "linear-gradient(to bottom, primary.main 50%, grey 50%)"
															// 			: "primary.main",
															// 	position:
															// 		"relative",
															// }}
														>
															{isActive && (
																<Box
																	sx={{
																		position:
																			"absolute",
																		top: `${percentage}%`,
																		left: "50%",
																		transform:
																			"translate(-50%, -50%)",
																		width: 10,
																		height: 10,
																		borderRadius:
																			"50%",
																		backgroundColor:
																			"primary.main",
																		animation: `${blink} 1s infinite`,
																	}}
																/>
															)}
														</TimelineConnector>
													)}
												</TimelineSeparator>

												<TimelineContent>
													<Typography
														variant="h6"
														component="span"
													>
														{status.label}
													</Typography>
													{status.changed_at && (
														<Typography>
															{moment(
																status.changed_at
															).format("hh:mm a")}
														</Typography>
													)}
													{status.lines?.map(
														(
															{ new_status },
															idx
														) => (
															<Typography
																key={idx}
															>
																{new_status}
															</Typography>
														)
													)}
												</TimelineContent>
											</TimelineItem>
										);
									})}
								</Timeline> */}

								<Box
									display={"flex"}
									justifyContent={"space-between"}
									py={1}
								>
									<Typography>Order Details:</Typography>

									<Box display="flex" alignItems="center">
										<Typography
											component="span"
											sx={{ cursor: "pointer" }}
											onClick={handleClick}
										>
											Shipping Charge ₹
											{order.total_shipping_charge?.toFixed(
												2
											)}
										</Typography>
										<IconButton
											size="small"
											onClick={handleClick}
										>
											<ExpandMore />
										</IconButton>
									</Box>
								</Box>
								<Divider />
								<Box
									sx={{
										py: 2,
										position: "relative",
										justifyContent: "space-between",
										// alignItems: "center",
										display: "flex",
									}}
								>
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1,
										}}
									>
										<Typography>
											Order Id {order.number}
										</Typography>
										<Typography>
											Order placed:
											{moment(order.date_placed).format(
												"YYYY MM DD hh:mm A"
											)}
										</Typography>
										<Typography>
											Payment Type: {order.is_cod ? "Postpaid (COD)" : "Prepaid"}
										</Typography>
										{order?.vouchers?.length > 0 ? (
											<Box mt={1}>
												{order.vouchers.map((voucher, index) => (
													<Box
														key={index}
														display="flex"
														justifyContent="space-between"
														alignItems="center"
														sx={{
															backgroundColor: "#f1f8f4",
															px: 2,
															py: 1,
															borderRadius: 1,
															mt: 1
														}}
													>
														<Typography color="success.main" fontWeight={500}>
															Discount : {voucher.name}
														</Typography>

														<Typography color="success.main" fontWeight="bold">
															- ₹{Number(voucher.amount).toFixed(2)}
														</Typography>
													</Box>
												))}
											</Box>
										) : (
											<Box mt={1}>
												<Typography color="text.secondary">
													No discount applied
												</Typography>
											</Box>
										)}
									</Box>

									<Chip
										variant="outlined"
										color="primary"
										label={
											order.status?.toLowerCase() ===
												"received"
												? "Order Recevied"
												: order.status
										}
									>
										{/* Hi */}
									</Chip>
								</Box>
							</Paper>
						</Grid>
						<Grid item xs={12} md={4}>
							<Paper elevation={2} sx={{ p: 2, height: "100%" }}>
								<Typography variant="h4" my={1}>
									Customer Details:
								</Typography>

								<Divider sx={{ my: 1 }} />

								{Object.entries(
									pick(owner, ["name", "email", "phone"])
								).map(([key, value], i) => (
									<Box
										key={`owner-${i}`}
										display="flex"
										mb={1}
										justifyContent={{
											xs: "space-between",
											md: "inherit",
										}}
									>
										<Typography
											sx={{
												// fontWeight: 500,
												minWidth: {
													xs: "auto",
													// sm: 180,
												},
												mr: 1,
												textTransform: "capitalize",
											}}
										>
											{key}:
										</Typography>
										<Typography>{value ?? "-"}</Typography>
									</Box>
								))}
							</Paper>
						</Grid>
						<Grid item md={12}>
							<Paper elevation={4} sx={{ p: 2, height: "100%" }}>
								<Fragment>
									<MUIDataTable
										title={"Products"}
										data={products}
										columns={columns(
											order,
											products,
											handleProductStatusOpen
										)}
										options={options}
									/>

									<Box
										sx={{
											maxWidth: 400,
											ml: "auto",
											p: 1,
											// fontSize: "0.95rem",
										}}
									>
										{/* Subtotal */}
										<Box
											display="flex"
											justifyContent="space-between"
											mb={1}
										>
											<Typography>Subtotal:</Typography>
											<Typography>
												₹{order.total_excl_tax}
											</Typography>
										</Box>
										{/* Shipping Charge */}
										<Box
											display="flex"
											justifyContent="space-between"
											mb={0.5}
										>
											<Typography>
												Delivery Fee:
											</Typography>
											<Box textAlign="right">
												<Box
													display="flex"
													alignItems="center"
													gap={1}
													justifyContent="flex-end"
												>
													{order.total_shipping_charge <
														order.shipping_charge && (
															<Typography
																sx={{
																	color: "#d32f2f",
																	textDecoration:
																		"line-through",
																	fontWeight:
																		"bold",
																	fontSize:
																		"0.9rem",
																}}
															>
																₹
																{order.shipping_charge.toFixed(
																	2
																)}
															</Typography>
														)}
													<Typography fontWeight="bold">
														₹
														{order.total_shipping_charge.toFixed(
															2
														)}
													</Typography>
												</Box>
											</Box>
										</Box>

										{order.partners.map((partner, i) => (
											<Box
												key={`order-partner-${i}`}
												display="flex"
												justifyContent="space-between"
												mb={1}
											>
												<Typography
													variant="caption"
													sx={{ pl: 1 }}
												>
													{partner.partner_name}
												</Typography>
												<Box textAlign="right" pr={2}>
													<Box
														display="flex"
														alignItems="center"
														gap={1}
														justifyContent="flex-end"
													>
														{parseInt(
															partner.shipping_fee
														) < partner.charges && (
																<Typography
																	variant="caption"
																	sx={{
																		color: "#d32f2f",
																		textDecoration:
																			"line-through",
																	}}
																>
																	₹
																	{partner.charges.toFixed(
																		2
																	)}
																</Typography>
															)}
														<Typography variant="caption">
															₹
															{parseFloat(
																partner.shipping_fee
															).toFixed(2)}
														</Typography>
													</Box>
												</Box>
											</Box>
										))}

										{/* Platform Charge */}
										<>
											<Box
												display="flex"
												justifyContent="space-between"
												mb={1}
											>
												<Typography>
													Other Seller Fee:
												</Typography>
												<Box style={
													{
														display: 'flex',
														flexDirection: 'row'

													}
												}>
													<Typography style={{ textDecoration: !order.include_platform_fee ? "line-through" : "none" }}>
														₹{order.platform_fee}

													</Typography>
													<Typography style={{ marginLeft: '5px' }}>{!order.include_platform_fee ? "Free" : ''}</Typography>
												</Box>

											</Box>
											{order.partners.map((partner, i) => (
												<Box
													key={`cod-partner-${i}`}
													display="flex"
													justifyContent="space-between"
													mb={1}
												>
													<Typography variant="caption" sx={{ pl: 1 }}>
														{partner.partner_name}
													</Typography>

													<Typography variant="caption">
														₹{parseFloat(partner.platform_fee).toFixed(2)}
													</Typography>
												</Box>
											))}
										</>
										{order.is_cod && (
											<>
												<Box
													display="flex"
													justifyContent="space-between"
													mb={1}
												>
													<Typography>
														COD Fee:
													</Typography>
													<Typography>
														₹{parseFloat(order.cod_charges.total_cod_fee).toFixed(2)}
													</Typography>

												</Box>
												{order.cod_charges?.cod_fee?.map((item, i) => (
													<Box
														key={`cod-partner-${i}`}
														display="flex"
														justifyContent="space-between"
														mb={1}
													>
														<Typography variant="caption" sx={{ pl: 1 }}>
															{item.partner.name}
														</Typography>

														<Typography variant="caption">
															₹{parseFloat(item.cod_fee).toFixed(2)}
														</Typography>
													</Box>
												))}
											</>
										)}
										{/* Grand Total */}
										<Divider sx={{ my: 1 }} />
										<Box
											display="flex"
											justifyContent="space-between"
										>
											<Typography fontWeight="bold">
												Total:
											</Typography>
											<Typography fontWeight="bold">
												₹{order.total_incl_tax}
											</Typography>
										</Box>
									</Box>
								</Fragment>
							</Paper>
						</Grid>

						<Grid item xs={12} md={4}>
							<Paper elevation={2} sx={{ p: 2, height: "100%" }}>
								<Typography variant="h4" my={1}>
									Shipping Details:
								</Typography>

								<Divider />

								<Box
									sx={{
										maxWidth: { md: 400 },
										// ml: "auto",
										p: { md: 2, sm: 1 },
										// fontSize: "0.95rem",
									}}
								>
									{[
										{
											label: "First name",
											value: shippingAddress.first_name,
										},
										{
											label: "Last name",
											value:
												shippingAddress.last_name ||
												"-",
										},
										{
											label: "1st Line of Address",
											value: shippingAddress.line1,
										},
										{
											label: "2nd Line of Address",
											value: shippingAddress.line2 || "-",
										},
										{
											label: "3rd Line of Address",
											value: shippingAddress.line3 || "-",
										},
										{
											label: "City",
											value: shippingAddress.line4,
										},
										{
											label: "State",
											value: shippingAddress.state,
										},
										{
											label: "Country",
											value:
												shippingAddress.country
													?.printable_name || "-",
										},
										{
											label: "Pincode",
											value: shippingAddress.postcode,
										},
									].map((field) => (
										<Box
											key={field.label}
											display="flex"
											mb={1}
											justifyContent={{
												xs: "space-between",
												md: "inherit",
											}}
										>
											<Typography
												sx={{
													// fontWeight: 500,
													minWidth: {
														xs: "auto",
														sm: 180,
													},
													mr: 1,
												}}
											>
												{field.label}:
											</Typography>
											<Typography>
												{field.value}
											</Typography>
										</Box>
									))}
								</Box>
							</Paper>
						</Grid>
						<Grid item xs={12} md={4}>
							<Paper elevation={2} sx={{ p: 2, height: "100%" }}>
								<Typography variant="h4" my={1}>
									Billing Details:
								</Typography>

								<Divider />

								<Box
									sx={{
										maxWidth: { md: 400 },

										// ml: "auto",
										p: { md: 2, sm: 1 },
										// fontSize: "0.95rem",
									}}
								>
									{[
										{
											label: "First name",
											value: shippingAddress.first_name,
										},
										{
											label: "Last name",
											value:
												shippingAddress.last_name ||
												"-",
										},
										{
											label: "1st Line",
											value: shippingAddress.line1,
										},
										{
											label: "2nd Line",
											value: shippingAddress.line2 || "-",
										},
										{
											label: "3rd Line",
											value: shippingAddress.line3 || "-",
										},
										{
											label: "City",
											value: shippingAddress.line4,
										},
										{
											label: "State",
											value: shippingAddress.state,
										},
										{
											label: "Country",
											value:
												shippingAddress.country
													?.printable_name || "-",
										},
										{
											label: "Pincode",
											value: shippingAddress.postcode,
										},
									].map((field) => (
										<Box
											key={field.label}
											display="flex"
											mb={1}
											justifyContent={{
												xs: "space-between",
												md: "inherit",
											}}
										>
											<Typography
												sx={{
													// fontWeight: 500,
													minWidth: {
														xs: "auto",
														sm: 180,
													},
													mr: 1,
												}}
											>
												{field.label}:
											</Typography>
											<Typography>
												{field.value}
											</Typography>
										</Box>
									))}
								</Box>
							</Paper>
						</Grid>
					</Grid>
				</Fragment>
			)}
			<LineStatusForm
				item={product}
				open={openProductStatus}
				handleClose={handleProductStatusClose}
			/>
			<OrderStatusForm
				order={order}
				open={openOrderStatus}
				handleClose={handleOrderStatusClose}
			/>

			{order && (
				<Popover
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					placement={"top"}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
					PaperProps={{
						sx: {
							p: 2,
							width: 300,
						},
					}}
				>
					<Box
						sx={{
							// maxWidth: 400,
							// ml: "auto",
							p: 1,
							// fontSize: "0.95rem",
						}}
					>
						{/* Subtotal */}
						<Box
							display="flex"
							justifyContent="space-between"
							mb={1}
						>
							<Typography variant="h4">Sellers</Typography>
							<Typography variant="h4">Price</Typography>
						</Box>
						<Divider sx={{ my: 2 }} />

						{order.partners.map((partner, i) => (
							<Box
								key={`partner-${i}`}
								display="flex"
								justifyContent="space-between"
								mb={1}
							>
								<Typography>{partner.partner_name}</Typography>
								<Box textAlign="right">
									<Box
										display="flex"
										alignItems="center"
										gap={1}
										justifyContent="flex-end"
									>
										{parseInt(partner.shipping_fee) <
											partner.charges && (
												<Typography
													// variant="caption"
													sx={{
														color: "#d32f2f",
														textDecoration:
															"line-through",
														fontWeight: "bold",
														fontSize: "0.9rem",
													}}
												>
													₹{partner.charges.toFixed(2)}
												</Typography>
											)}
										<Typography>
											₹
											{parseFloat(
												partner.shipping_fee
											).toFixed(2)}
										</Typography>
									</Box>
								</Box>
							</Box>
						))}
						<Divider sx={{ my: 1 }} />
						<Box
							display="flex"
							justifyContent="space-between"
							mb={0.5}
						>
							<Typography>Total:</Typography>
							<Box textAlign="right">
								<Box
									display="flex"
									alignItems="center"
									gap={1}
									justifyContent="flex-end"
								>
									{order.total_shipping_charge <
										order.shipping_charge && (
											<Typography
												sx={{
													color: "#d32f2f",
													textDecoration: "line-through",
													fontWeight: "bold",
													fontSize: "0.9rem",
												}}
											>
												₹{order.shipping_charge.toFixed(2)}
											</Typography>
										)}
									<Typography fontWeight="bold">
										₹
										{order.total_shipping_charge.toFixed(2)}
									</Typography>
								</Box>
							</Box>
						</Box>
					</Box>
				</Popover>
			)}

			<Dialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle
					component="h3"
					id="alert-dialog-title"
					sx={{ color: (theme) => theme.palette.warning.main }}
				>
					Warning
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						<Typography color="primary" variant="p">
							{message}
						</Typography>
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ px: 3, py: 2 }}>
					{refresh ? (
						<Button
							onClick={() => navigate(-1)}
							variant="contained"
						>
							Go Back
						</Button>
					) : (
						<>
							<Button
								onClick={() => setDialogOpen(false)}
								variant="contained"
								color="error"
							>
								No
							</Button>
							<Button
								onClick={() => updateStatus(order)}
								variant="contained"
							>
								Yes, Update
							</Button>
						</>
					)}
				</DialogActions>
			</Dialog>

			<ConfirmModal
				message={message}
				setOpen={setConfirmOpen}
				open={confirmOpen}
			></ConfirmModal>
		</Box>
	);
};
